import { GraphData } from "../types";

export const exampleHospital: GraphData = {
  "nodes": [
      {
          "id": "0",
          "type": "root_node",
          "data": {
              "label": "医院科室",
              "backgroundColor": "#6b3747",
              "color": "#fff",
              "border": "none"
          },
          "position": {
              "x": 32,
              "y": 323
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "2740",
          "type": "text_node",
          "data": {
              "label": "临床科室",
              "backgroundColor": "#f9633f",
              "color": "#fff",
              "border": "none",
              "expanded": true
          },
          "position": {
              "x": 158,
              "y": 95
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "2741",
          "type": "text_node",
          "data": {
              "label": "内科",
              "border": "none",
              "expanded": false
          },
          "position": {
              "x": 296,
              "y": 0
          },
          "measured": {
              "width": 40,
              "height": 28
          },
          "selected": false
      },
      {
          "id": "2742",
          "type": "text_node",
          "data": {
              "label": "外科",
              "border": "none",
              "expanded": false
          },
          "position": {
              "x": 296,
              "y": 38
          },
          "measured": {
              "width": 40,
              "height": 28
          },
          "selected": false
      },
      {
          "id": "2743",
          "type": "text_node",
          "data": {
              "label": "妇产科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 76
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2744",
          "type": "text_node",
          "data": {
              "label": "儿科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 114
          },
          "measured": {
              "width": 40,
              "height": 28
          }
      },
      {
          "id": "2745",
          "type": "text_node",
          "data": {
              "label": "神经科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 152
          },
          "measured": {
              "width": 52,
              "height": 28
          },
          "selected": false
      },
      {
          "id": "2746",
          "type": "text_node",
          "data": {
              "label": "皮肤科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 190
          },
          "measured": {
              "width": 52,
              "height": 28
          },
          "selected": false
      },
      {
          "id": "2747",
          "type": "text_node",
          "data": {
              "label": "辅助科室",
              "backgroundColor": "#35c290",
              "color": "#fff",
              "border": "none"
          },
          "position": {
              "x": 158,
              "y": 323
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "2748",
          "type": "text_node",
          "data": {
              "label": "影像科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 228
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2749",
          "type": "text_node",
          "data": {
              "label": "检验科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 266
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2750",
          "type": "text_node",
          "data": {
              "label": "药剂科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 304
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2751",
          "type": "text_node",
          "data": {
              "label": "麻醉科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 342
          },
          "measured": {
              "width": 52,
              "height": 28
          },
          "selected": false
      },
      {
          "id": "2752",
          "type": "text_node",
          "data": {
              "label": "放射科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 380
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2753",
          "type": "text_node",
          "data": {
              "label": "病理科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 418
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2754",
          "type": "text_node",
          "data": {
              "label": "后勤保障科室",
              "backgroundColor": "#7fc0f8",
              "color": "#fff",
              "border": "none"
          },
          "position": {
              "x": 158,
              "y": 532
          },
          "measured": {
              "width": 88,
              "height": 28
          }
      },
      {
          "id": "2755",
          "type": "text_node",
          "data": {
              "label": "医务管理科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 456
          },
          "measured": {
              "width": 76,
              "height": 28
          }
      },
      {
          "id": "2756",
          "type": "text_node",
          "data": {
              "label": "人力资源科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 494
          },
          "measured": {
              "width": 76,
              "height": 28
          }
      },
      {
          "id": "2757",
          "type": "text_node",
          "data": {
              "label": "财务科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 532
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2758",
          "type": "text_node",
          "data": {
              "label": "信息科",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 570
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "2759",
          "type": "text_node",
          "data": {
              "label": "后勤保障中心",
              "border": "none"
          },
          "position": {
              "x": 296,
              "y": 608
          },
          "measured": {
              "width": 88,
              "height": 28
          }
      },
      {
          "id": "169",
          "type": "text_node",
          "data": {
              "label": "普外科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 190
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      },
      {
          "id": "170",
          "type": "text_node",
          "data": {
              "label": "骨科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 228
          },
          "measured": {
              "width": 40,
              "height": 28
          }
      },
      {
          "id": "171",
          "type": "text_node",
          "data": {
              "label": "泌尿外科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 266
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "658",
          "type": "text_node",
          "data": {
              "label": "呼吸内科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 0
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "659",
          "type": "text_node",
          "data": {
              "label": "心血管内科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 38
          },
          "measured": {
              "width": 76,
              "height": 28
          }
      },
      {
          "id": "660",
          "type": "text_node",
          "data": {
              "label": "消化内科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 76
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "661",
          "type": "text_node",
          "data": {
              "label": "内分泌科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 114
          },
          "measured": {
              "width": 64,
              "height": 28
          }
      },
      {
          "id": "662",
          "type": "text_node",
          "data": {
              "label": "血液科",
              "border": "none"
          },
          "position": {
              "x": 428,
              "y": 152
          },
          "measured": {
              "width": 52,
              "height": 28
          }
      }
  ],
  "edges": [
      {
          "id": "0-2740",
          "source": "0",
          "target": "2740",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2740-2741",
          "source": "2740",
          "target": "2741",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2740-2742",
          "source": "2740",
          "target": "2742",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2740-2743",
          "source": "2740",
          "target": "2743",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2740-2744",
          "source": "2740",
          "target": "2744",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2740-2745",
          "source": "2740",
          "target": "2745",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2740-2746",
          "source": "2740",
          "target": "2746",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "0-2747",
          "source": "0",
          "target": "2747",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "2747-2748",
          "source": "2747",
          "target": "2748",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "2747-2749",
          "source": "2747",
          "target": "2749",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "2747-2750",
          "source": "2747",
          "target": "2750",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "2747-2751",
          "source": "2747",
          "target": "2751",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "2747-2752",
          "source": "2747",
          "target": "2752",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "2747-2753",
          "source": "2747",
          "target": "2753",
          "type": "bezier",
          "data": {
              "stroke": "#35c290"
          }
      },
      {
          "id": "0-2754",
          "source": "0",
          "target": "2754",
          "type": "bezier",
          "data": {
              "stroke": "#7fc0f8"
          }
      },
      {
          "id": "2754-2755",
          "source": "2754",
          "target": "2755",
          "type": "bezier",
          "data": {
              "stroke": "#7fc0f8"
          }
      },
      {
          "id": "2754-2756",
          "source": "2754",
          "target": "2756",
          "type": "bezier",
          "data": {
              "stroke": "#7fc0f8"
          }
      },
      {
          "id": "2754-2757",
          "source": "2754",
          "target": "2757",
          "type": "bezier",
          "data": {
              "stroke": "#7fc0f8"
          }
      },
      {
          "id": "2754-2758",
          "source": "2754",
          "target": "2758",
          "type": "bezier",
          "data": {
              "stroke": "#7fc0f8"
          }
      },
      {
          "id": "2754-2759",
          "source": "2754",
          "target": "2759",
          "type": "bezier",
          "data": {
              "stroke": "#7fc0f8"
          }
      },
      {
          "id": "2742-169",
          "source": "2742",
          "target": "169",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2742-170",
          "source": "2742",
          "target": "170",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2742-171",
          "source": "2742",
          "target": "171",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2741-658",
          "source": "2741",
          "target": "658",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2741-659",
          "source": "2741",
          "target": "659",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2741-660",
          "source": "2741",
          "target": "660",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2741-661",
          "source": "2741",
          "target": "661",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      },
      {
          "id": "2741-662",
          "source": "2741",
          "target": "662",
          "type": "bezier",
          "data": {
              "stroke": "#f9633f"
          }
      }
  ]
}

export const exampleCourse: GraphData = {
    "nodes": [
        {
            "id": "0",
            "type": "root_node",
            "data": {
                "label": "中国初中物理核心知识",
                "backgroundColor": "#FFB6C1",
                "color": "#1f1f1f",
                "border": "none"
            },
            "position": {
                "x": 0.3100775193798597,
                "y": 271.968992248062
            },
            "measured": {
                "width": 136,
                "height": 28
            },
            "selected": true,
            "dragging": false
        },
        {
            "id": "1297",
            "type": "text_node",
            "data": {
                "label": "力与运动",
                "backgroundColor": "#FFE4B5",
                "color": "#1f1f1f",
                "border": "none"
            },
            "position": {
                "x": 194,
                "y": 38
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        },
        {
            "id": "1298",
            "type": "text_node",
            "data": {
                "label": "力的概念",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 0
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        },
        {
            "id": "1299",
            "type": "text_node",
            "data": {
                "label": "牛顿定律",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 38
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        },
        {
            "id": "1300",
            "type": "text_node",
            "data": {
                "label": "运动的描述",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 76
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1301",
            "type": "text_node",
            "data": {
                "label": "能量",
                "backgroundColor": "#90EE90",
                "color": "#1f1f1f",
                "border": "none"
            },
            "position": {
                "x": 194,
                "y": 152
            },
            "measured": {
                "width": 40,
                "height": 28
            }
        },
        {
            "id": "1302",
            "type": "text_node",
            "data": {
                "label": "能量的转化",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 114
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1303",
            "type": "text_node",
            "data": {
                "label": "动能与势能",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 152
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1304",
            "type": "text_node",
            "data": {
                "label": "机械能守恒",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 190
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1305",
            "type": "text_node",
            "data": {
                "label": "热学",
                "backgroundColor": "#87CEEB",
                "color": "#1f1f1f",
                "border": "none"
            },
            "position": {
                "x": 194,
                "y": 266
            },
            "measured": {
                "width": 40,
                "height": 28
            }
        },
        {
            "id": "1306",
            "type": "text_node",
            "data": {
                "label": "温度与热量",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 228
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1307",
            "type": "text_node",
            "data": {
                "label": "热传导",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 266
            },
            "measured": {
                "width": 52,
                "height": 28
            }
        },
        {
            "id": "1308",
            "type": "text_node",
            "data": {
                "label": "热胀冷缩",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 304
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        },
        {
            "id": "1309",
            "type": "text_node",
            "data": {
                "label": "光学",
                "backgroundColor": "#D8BFD8",
                "color": "#1f1f1f",
                "border": "none"
            },
            "position": {
                "x": 194,
                "y": 380
            },
            "measured": {
                "width": 40,
                "height": 28
            }
        },
        {
            "id": "1310",
            "type": "text_node",
            "data": {
                "label": "光的传播",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 342
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        },
        {
            "id": "1311",
            "type": "text_node",
            "data": {
                "label": "反射与折射",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 380
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1312",
            "type": "text_node",
            "data": {
                "label": "光的颜色",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 418
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        },
        {
            "id": "1313",
            "type": "text_node",
            "data": {
                "label": "电学",
                "backgroundColor": "#FFDAB9",
                "color": "#1f1f1f",
                "border": "none"
            },
            "position": {
                "x": 194,
                "y": 494
            },
            "measured": {
                "width": 40,
                "height": 28
            }
        },
        {
            "id": "1314",
            "type": "text_node",
            "data": {
                "label": "电流与电压",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 456
            },
            "measured": {
                "width": 76,
                "height": 28
            }
        },
        {
            "id": "1315",
            "type": "text_node",
            "data": {
                "label": "电路的基本知识",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 494
            },
            "measured": {
                "width": 100,
                "height": 28
            }
        },
        {
            "id": "1316",
            "type": "text_node",
            "data": {
                "label": "电磁现象",
                "border": "none"
            },
            "position": {
                "x": 310,
                "y": 532
            },
            "measured": {
                "width": 64,
                "height": 28
            }
        }
    ],
    "edges": [
        {
            "id": "0-1297",
            "source": "0",
            "target": "1297",
            "type": "bezier",
            "data": {
                "stroke": "#FFE4B5"
            }
        },
        {
            "id": "1297-1298",
            "source": "1297",
            "target": "1298",
            "type": "bezier",
            "data": {
                "stroke": "#FFE4B5"
            }
        },
        {
            "id": "1297-1299",
            "source": "1297",
            "target": "1299",
            "type": "bezier",
            "data": {
                "stroke": "#FFE4B5"
            }
        },
        {
            "id": "1297-1300",
            "source": "1297",
            "target": "1300",
            "type": "bezier",
            "data": {
                "stroke": "#FFE4B5"
            }
        },
        {
            "id": "0-1301",
            "source": "0",
            "target": "1301",
            "type": "bezier",
            "data": {
                "stroke": "#90EE90"
            }
        },
        {
            "id": "1301-1302",
            "source": "1301",
            "target": "1302",
            "type": "bezier",
            "data": {
                "stroke": "#90EE90"
            }
        },
        {
            "id": "1301-1303",
            "source": "1301",
            "target": "1303",
            "type": "bezier",
            "data": {
                "stroke": "#90EE90"
            }
        },
        {
            "id": "1301-1304",
            "source": "1301",
            "target": "1304",
            "type": "bezier",
            "data": {
                "stroke": "#90EE90"
            }
        },
        {
            "id": "0-1305",
            "source": "0",
            "target": "1305",
            "type": "bezier",
            "data": {
                "stroke": "#87CEEB"
            }
        },
        {
            "id": "1305-1306",
            "source": "1305",
            "target": "1306",
            "type": "bezier",
            "data": {
                "stroke": "#87CEEB"
            }
        },
        {
            "id": "1305-1307",
            "source": "1305",
            "target": "1307",
            "type": "bezier",
            "data": {
                "stroke": "#87CEEB"
            }
        },
        {
            "id": "1305-1308",
            "source": "1305",
            "target": "1308",
            "type": "bezier",
            "data": {
                "stroke": "#87CEEB"
            }
        },
        {
            "id": "0-1309",
            "source": "0",
            "target": "1309",
            "type": "bezier",
            "data": {
                "stroke": "#D8BFD8"
            }
        },
        {
            "id": "1309-1310",
            "source": "1309",
            "target": "1310",
            "type": "bezier",
            "data": {
                "stroke": "#D8BFD8"
            }
        },
        {
            "id": "1309-1311",
            "source": "1309",
            "target": "1311",
            "type": "bezier",
            "data": {
                "stroke": "#D8BFD8"
            }
        },
        {
            "id": "1309-1312",
            "source": "1309",
            "target": "1312",
            "type": "bezier",
            "data": {
                "stroke": "#D8BFD8"
            }
        },
        {
            "id": "0-1313",
            "source": "0",
            "target": "1313",
            "type": "bezier",
            "data": {
                "stroke": "#FFDAB9"
            }
        },
        {
            "id": "1313-1314",
            "source": "1313",
            "target": "1314",
            "type": "bezier",
            "data": {
                "stroke": "#FFDAB9"
            }
        },
        {
            "id": "1313-1315",
            "source": "1313",
            "target": "1315",
            "type": "bezier",
            "data": {
                "stroke": "#FFDAB9"
            }
        },
        {
            "id": "1313-1316",
            "source": "1313",
            "target": "1316",
            "type": "bezier",
            "data": {
                "stroke": "#FFDAB9"
            }
        }
    ]
}

export const examples: { name: string; data: GraphData }[] = [
  { name: '医院科室分类', data: exampleHospital },
  { name: '初中物理', data: exampleCourse },
];